export const selectInput = () => ({
    '& .ant-select-selection': {
        width: 317,
        maxWidth: '100%',
    },
});
